"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var columns_1 = require("../../DataGrid/context/columns");
var props_1 = require("../context/props");
var TableHeader = function () {
    var columnsState = (0, columns_1.useColumnsContext)().columnsState;
    var classes = (0, props_1.usePropsContext)().classes;
    var _a = (classes || {}).header, _b = _a === void 0 ? { cell: '' } : _a, classesCell = _b.cell;
    return (react_1.default.createElement(TableHead_1.default, null,
        react_1.default.createElement(TableRow_1.default, null, columnsState.map(function (_a) {
            var _b = _a.label, label = _b === void 0 ? '' : _b, id = _a.id, width = _a.width;
            return (react_1.default.createElement(TableCell_1.default, { key: id, classes: { root: classesCell }, width: width },
                react_1.default.createElement("b", null, label)));
        }))));
};
exports.default = TableHeader;
